import login from './login.json';
import logout from './logout.json';
import mfa from './mfa.json';
import recoverypwd from './recoverypwd.json';
import changepwd from './changepwd.json';
import password from './password.json';
import account from './account.json';

export default {
  login,
  logout,
  mfa,
  recoverypwd,
  changepwd,
  password,
  account,
};
